import { Moon, Sun } from '../components/icons';
import { useTheme } from '../store/themeContext';

export default function ThemeToggle() {
  const { mode, toggleMode } = useTheme();

  return (
    <button
      type="button"
      onClick={toggleMode}
      aria-label="Alternar tema"
      className="inline-flex h-10 items-center gap-2 rounded-full border border-borderLight bg-cardLight px-2.5 text-xs font-semibold text-slate-700 transition hover:bg-slate-100 dark:border-borderDark dark:bg-cardDark dark:text-slate-200 dark:hover:bg-slate-800"
    >
      <span className="ui-icon-chip-soft">{mode === 'dark' ? <Moon /> : <Sun />}</span>
      {mode === 'dark' ? 'Escuro' : 'Claro'}
    </button>
  );
}
